export const infoConfig = {
	name: "Fradol",
	guests: 8,
	extraGuests: 5,
	stars: 3,
	coords: [43.25712017686054, 17.06111091422302],
	googleMapsLink: 'https://maps.app.goo.gl/1JD9aaDchM1bL7ct5',
	address: 'Kamena 41, 21325, Tučepi, Croatia',
	wappLink: 'https://wa.me/38598419904',
	wappLink2: 'https://wa.me/385992563039', 
	phone: '+385 98 419 904',
	secondaryPhone: '+385 99 256 3039',
	email: 'velaw900@gmail.com',
	facebook: 'https://www.facebook.com/vidas9801',
	authKey: '21fad881-29ad-4bf8-8ccc-9f18e69df92a',
};

export const discoverLinks = [
	{
		name: 'Makarska',
		link: 'https://www.makarska-info.hr/',
	},
	{
		name: 'Biokovo',
		link: 'https://pp-biokovo.hr/en',
	},
	{
		name: 'Skywalk',
		link: 'https://pp-biokovo.hr/en/skywalk-biokovo',
	},
	{
		name: 'Geo-park',
		link: 'https://gp-biokovoimotski.com/geopark-biokovo/',
	},
	{
		name: 'Ston',
		link: 'https://www.ston.hr/',
	},
	{
		name: 'Narona',
		link: 'https://www.a-m-narona.hr/',
	},
]

import { markRaw } from "vue";
import ParkingIcon from "@/components/icons/ParkingIcon.vue";
import PawIcon from "@/components/icons/PawIcon.vue";
import PoolIcon from "@/components/icons/PoolIcon.vue";
import HomeIcon from "@/components/icons/HomeIcon.vue";
import WifiIcon from "@/components/icons/WifiIcon.vue";
import NoSmokingIcon from "@/components/icons/NoSmokingIcon.vue";
import GrillIcon from "@/components/icons/GrillIcon.vue";
import WasherIcon from "@/components/icons/WasherIcon.vue";
import ACIcon from "@/components/icons/ACIcon.vue";
import SeaViewIcon from "@/components/icons/SeaViewIcon.vue";
import BeachIcon from "@/components/icons/BeachIcon.vue";
import BabyIcon from "@/components/icons/BabyIcon.vue";
import CoffeeIcon from "@/components/icons/CoffeeIcon.vue";
import BalconyIcon from "@/components/icons/BalconyIcon.vue";
import MicrowaveIcon from "@/components/icons/MicrowaveIcon.vue";
import TvIcon from "@/components/icons/TvIcon.vue";
import ShowerIcon from "@/components/icons/ShowerIcon.vue";


export const services = [
	{
		name: 'services.squareMeters',
		icon: markRaw(HomeIcon),
	},
	{
		name: 'services.freeParking',
		icon: markRaw(ParkingIcon),
	},
	{
		name: 'services.freeWifi',
		icon: markRaw(WifiIcon),
	},
	{
		name: 'services.petFriendly',
		icon: markRaw(PawIcon),
	},
	{
		name: 'services.grill',
		icon: markRaw(GrillIcon),
	},
	{
		name: 'services.noSmoking',
		icon: markRaw(NoSmokingIcon),
	},
	{
		name: 'services.privateOutdoorPool',
		icon: markRaw(PoolIcon),
	},
	{
		name: 'services.washer',
		icon: markRaw(WasherIcon),
	},
	{
		name: 'services.dishWasher',
		icon: markRaw(WasherIcon),
	},
	{
		name: 'services.microwave',
		icon: markRaw(MicrowaveIcon),
	},
	{
		name: 'services.tv',
		icon: markRaw(TvIcon),
	},
	{
		name: 'services.airCondition',
		icon: markRaw(ACIcon),
	},
	{
		name: 'services.seaView',
		icon: markRaw(SeaViewIcon),
	},
	{
		name: 'services.beach',
		icon: markRaw(BeachIcon),
	},
	{
		name: 'services.babyBed',
		icon: markRaw(BabyIcon),
	},
	{
		name: 'services.coffeeMachine',
		icon: markRaw(CoffeeIcon),
	},
	{
		name: 'services.terrace',
		icon: markRaw(BalconyIcon),
	},
	{
		name: 'services.closedLoggia',
		icon: markRaw(BalconyIcon),
	},
];

export const apartments = [
	{
		justGallery: true,
		color: 'gallery',
		images: [
			'images/other/1.jpg',
			'images/other/2.jpg',
			'images/other/3.jpg',
			'images/other/4.jpg',
			'images/other/5.jpg',
			'images/other/6.jpg',
			'images/other/7.jpg',
			'images/other/8.jpg',
			'images/other/9.jpg',
			'images/other/10.jpg',
			'images/other/11.jpg',
			'images/other/12.jpg',
			'images/other/13.jpg',
			'images/other/14.jpg',
			'images/other/15.jpg',
			'images/other/16.jpeg',
		],
		galleryPreview: [
			'images/thumbnails/other/1.jpg',
			'images/thumbnails/other/2.jpg',
			'images/thumbnails/other/3.jpg',
			'images/thumbnails/other/4.jpg',
			'images/thumbnails/other/5.jpg',
			'images/thumbnails/other/6.jpg',
		],
	},
	{
		color: 'lobster',
		capacity: '2',
		text: 'apartments.text.lobster',
		services: [
			{
				name: 'services.studio',
				icon: markRaw(HomeIcon),
			},
			{
				name: 'services.freeWifi',
				icon: markRaw(WifiIcon),
			},
			{
				name: 'services.airCondition',
				icon: markRaw(ACIcon),
			},
			{
				name: 'services.seaView',
				icon: markRaw(SeaViewIcon),
			},
			{
				name: 'services.freeParking',
				icon: markRaw(ParkingIcon),
			},
			{
				name: 'services.beach',
				icon: markRaw(BeachIcon),
			},
			{
				name: 'services.babyBed',
				icon: markRaw(BabyIcon),
			},
			{
				name: 'services.coffeeMachine',
				icon: markRaw(CoffeeIcon),
			},
			{
				name: 'services.dishWasher',
				icon: markRaw(WasherIcon),
			},
			{
				name: 'services.microwave',
				icon: markRaw(MicrowaveIcon),
			},
			{
				name: 'services.tv',
				icon: markRaw(TvIcon),
			},
			{
				name: 'services.terrace',
				icon: markRaw(BalconyIcon),
			},
		],
		images: [
			'images/lobster/1.jpg',
			'images/lobster/2.jpg',
			'images/lobster/3.jpg',
			'images/lobster/11.jpg',
			'images/lobster/12.jpg',
			'images/lobster/10.jpg',
			'images/lobster/8.jpg',
			'images/lobster/9.jpg',
		],
		galleryPreview: [
			'images/thumbnails/lobster/1.jpg',
			'images/thumbnails/lobster/2.jpg',
			'images/thumbnails/lobster/3.jpg',
			'images/thumbnails/lobster/8.jpg',
			'images/thumbnails/lobster/9.jpg',
			'images/thumbnails/lobster/10.jpg',
		],
	},
	{
		color: 'lavender',
		capacity: '2 + 2',
		text: 'apartments.text.lavender',
		services: [
			{
				name: 'services.freeWifi',
				icon: markRaw(WifiIcon),
			},
			{
				name: 'services.airCondition',
				icon: markRaw(ACIcon),
			},
			{
				name: 'services.seaView',
				icon: markRaw(SeaViewIcon),
			},
			{
				name: 'services.freeParking',
				icon: markRaw(ParkingIcon),
			},
			{
				name: 'services.beach',
				icon: markRaw(BeachIcon),
			},
			{
				name: 'services.babyBed',
				icon: markRaw(BabyIcon),
			},
			{
				name: 'services.coffeeMachine',
				icon: markRaw(CoffeeIcon),
			},
			{
				name: 'services.dishWasher',
				icon: markRaw(WasherIcon),
			},
			{
				name: 'services.microwave',
				icon: markRaw(MicrowaveIcon),
			},
			{
				name: 'services.tv',
				icon: markRaw(TvIcon),
			},
			{
				name: 'services.closedLoggia',
				icon: markRaw(BalconyIcon),
			},
		],
		images: [
			'images/lavender/1.jpg',
			'images/lavender/2.jpg',
			'images/lavender/3.jpg',
			'images/lavender/4.jpg',
			'images/lavender/5.jpg',
			'images/lavender/6.jpg',
			'images/lavender/7.jpg',
			'images/lavender/8.jpg',
		],
		galleryPreview: [
			'images/thumbnails/lavender/1.jpg',
			'images/thumbnails/lavender/2.jpg',
			'images/thumbnails/lavender/3.jpg',
			'images/thumbnails/lavender/4.jpg',
			'images/thumbnails/lavender/5.jpg',
			'images/thumbnails/lavender/6.jpg',
		],
	},
	{
		color: 'sea',
		capacity: '4 + 1',
		text: 'apartments.text.sea',
		services: [
			{
				name: 'services.extraBathrooms',
				icon: markRaw(ShowerIcon),
			},
			{
				name: 'services.freeWifi',
				icon: markRaw(WifiIcon),
			},
			{
				name: 'services.airCondition',
				icon: markRaw(ACIcon),
			},
			{
				name: 'services.seaView',
				icon: markRaw(SeaViewIcon),
			},
			{
				name: 'services.freeParking',
				icon: markRaw(ParkingIcon),
			},
			{
				name: 'services.beach',
				icon: markRaw(BeachIcon),
			},
			{
				name: 'services.babyBed',
				icon: markRaw(BabyIcon),
			},
			{
				name: 'services.coffeeMachine',
				icon: markRaw(CoffeeIcon),
			},
			{
				name: 'services.dishWasher',
				icon: markRaw(WasherIcon),
			},
			{
				name: 'services.microwave',
				icon: markRaw(MicrowaveIcon),
			},
			{
				name: 'services.tv',
				icon: markRaw(TvIcon),
			},
			{
				name: 'services.terrace',
				icon: markRaw(BalconyIcon),
			},
		],
		images: [
			'images/sea/1.jpg',
			'images/sea/2.jpg',
			'images/sea/3.jpg',
			'images/sea/12.jpg',
			'images/sea/7.jpg',
			'images/sea/11.jpg',
			'images/sea/10.jpg',
			'images/sea/9.jpg',
		],
		galleryPreview: [
			'images/thumbnails/sea/1.jpg',
			'images/thumbnails/sea/2.jpg',
			'images/thumbnails/sea/3.jpg',
			'images/thumbnails/sea/7.jpg',
			'images/thumbnails/sea/9.jpg',
			'images/thumbnails/sea/10.jpg',
		],
	},
	{
		color: 'olive',
		capacity: '5 + 1',
		text: 'apartments.text.olive',
		services: [
			{
				name: 'services.freeWifi',
				icon: markRaw(WifiIcon),
			},
			{
				name: 'services.airCondition',
				icon: markRaw(ACIcon),
			},
			{
				name: 'services.seaView',
				icon: markRaw(SeaViewIcon),
			},
			{
				name: 'services.freeParking',
				icon: markRaw(ParkingIcon),
			},
			{
				name: 'services.beach',
				icon: markRaw(BeachIcon),
			},
			{
				name: 'services.babyBed',
				icon: markRaw(BabyIcon),
			},
			{
				name: 'services.coffeeMachine',
				icon: markRaw(CoffeeIcon),
			},
			{
				name: 'services.washer',
				icon: markRaw(WasherIcon),
			},
			{
				name: 'services.dishWasher',
				icon: markRaw(WasherIcon),
			},
			{
				name: 'services.microwave',
				icon: markRaw(MicrowaveIcon),
			},
			{
				name: 'services.tv',
				icon: markRaw(TvIcon),
			},
			{
				name: 'services.terrace',
				icon: markRaw(BalconyIcon),
			},
		],
		images: [
			'images/olive/19.jpg',
			'images/olive/20.jpg',
			'images/olive/21.jpg',
			'images/olive/22.jpg',
			'images/olive/6.jpg',
			'images/olive/14.jpg',
			'images/olive/11.jpg',
			'images/olive/17.jpg',
			'images/olive/18.jpg',
			'images/olive/15.jpg',
			'images/olive/16.jpg',
			'images/olive/13.jpg',
		],
		galleryPreview: [
			'images/thumbnails/olive/6.jpg',
			'images/thumbnails/olive/11.jpg',
			'images/thumbnails/olive/13.jpg',
			'images/thumbnails/olive/14.jpg',
			'images/thumbnails/olive/15.jpg',
			'images/thumbnails/olive/16.jpg',
		],
	},
];
